import React from "react";
import { useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import SelectFaseFormik from "../../../../components/UI/SelectInput/SelectFaseFormik";
import SelectInputCachedFormik from "../../../../components/UI/SelectInput/SelectInputCachedFormik";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";

const useFormBuscaAvancada = () => {
  const validationSchema = Yup.object().shape({
    NumAuto: Yup.string().default(""),
    dtInicio: Yup.string().default(""),
    dtFim: Yup.string().default(""),
    sqSituacao: Yup.string().default(""),
    NuTipoAcaoFiscal: Yup.string().default(""),
    NuFase: Yup.string().default(""),
    Identificador: Yup.string().default(""),
    MatriculaAuditor: Yup.string().default(""),
    nomeAuditor: Yup.string().default(""),
    nomeDiretor: Yup.string().default(""),
    codigoDiretor: Yup.string().default(""),
    situacaoProrroga: Yup.string().default(""),
    qtDiasProrroga: Yup.string().default(""),
  });

  const initialValues = {};
  validationSchema._nodes.forEach((key) => {
    initialValues[key] = "";
  });

  const { executarOsSearchParameters } = useSelector((state) => state.executarOsSearch);

  const formik = useFormik({
    initialValues: executarOsSearchParameters,
    validationSchema,
  });

  const form = (
    <Row>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Nº do Auto</Form.Label>
        <TextInputFormik formik={formik} field="NumAuto" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Data Início Geração de OS</Form.Label>
        <DateTimeInputFormik formik={formik} field="dtInicio" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Data Fim Geração de OS</Form.Label>
        <DateTimeInputFormik formik={formik} field="dtFim" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Tipo de Ação Fiscal</Form.Label>
        <br />
        <SelectInputCachedFormik formik={formik} field="NuTipoAcaoFiscal" tipoItem="tipo-acao-fiscal" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Fase</Form.Label>
        <SelectFaseFormik formik={formik} field="NuFase" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>IE/CNPJ/CPF</Form.Label>
        <TextInputFormik formik={formik} field="Identificador" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Matrícula Auditor</Form.Label>
        <TextInputFormik formik={formik} field="MatriculaAuditor" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Nome Auditor</Form.Label>
        <TextInputFormik formik={formik} field="nomeAuditor" />
      </Form.Group>
      <Form.Group as={Col} sm={6} md={3}>
        <Form.Label>Nome Diretor</Form.Label>
        <TextInputFormik formik={formik} field="nomeDiretor" />
      </Form.Group>
    </Row>
  );

  return {
    formik,
    form,
  };
};

export default useFormBuscaAvancada;
